<template>
    <div class="totalAddress"  v-loading="totalAddressLoading" >
    <!-- 对数线性显示切换 -->
    <!-- <el-row>
        <el-col>
          <el-button @click="handelLineSwitch"
          style="height:35px;border-radius:6px;margin-left: 5px;line-height: 5px;"
            >{{ $t(`home.switch`)
            }}<span class="according"> {{ $t(switch3) }}</span></el-button
          >
        </el-col>
      </el-row> -->
      <!-- <Dropdown
            :dataSelection="dataSelection"
            :onSelect="handleSelect"
            :realTimeData="realTimeData"
            style="margin: 10px 0px;"
          ></Dropdown> -->
       <div id="totalAddressBox"   style="width: 100%; min-height: 700px">
  
       </div>
    </div>
  </template>
  
  <script>
  import indexJs from "./index";
  export default {
      mixins:[indexJs]
  }
  </script>
  
  <style lang="scss" scoped>
      // .totalAddress{
      //     padding: 0px  30px;
      // } 
  </style>